import { create } from 'vue-modal-dialogs';
import router from '../router';
import ConfirmUI from '../components/common/dialogs/confirm';
import ErrorUI from '../components/common/dialogs/error';

const confirmDialog = create(ConfirmUI),
	errorDialog = create(ErrorUI, 'errorCode'),
	errorDialogHandler = (errorCode, i18nData) => {
		if (process.env.NODE_ENV !== 'prod') console.error(errorCode);
		switch (errorCode) {
			case 'NEED_TO_SET_THE_PASSWORD':
				return confirmDialog({
					title: 'settings.social-link.need-password.title',
					content: router.app.$t('settings.social-link.need-password.desc', i18nData),
					confirmLabel: 'settings.social-link.need-password.create-password',
					confirmFunction: () => router.push({ name: 'create-change-password' }),
					cancelLabel: 'cancel',
				});
			default:
				return errorDialog(errorCode);
		}
	},
	dialogHelper = {
		install(vue) {
			vue.prototype.$dialog = { confirm: confirmDialog, error: errorDialogHandler };
		},
	};

export default dialogHelper;



// WEBPACK FOOTER //
// ./src/plugins/dialog-helper.js